@if (tiles?.length > 0) {
  <section class="tiles-container">
    @for (tile of tiles; track tile) {
      <article class="tile-container">
        <div class="description">
          <p class="description__header">{{ tile.label }}</p>
          <p class="description__value">{{ tile.value }}</p>
        </div>
        <div class="copy-action" [copyToClipboard]="tile.valueToCopy" [copyInfo]="tile.copyInfo">
          <span class="bpi__icon-clipboard"></span>
        </div>
      </article>
    }
  </section>
}
